import { useQuery } from '@tanstack/react-query';

import { type ResourceId } from '@app/client';
import { callGetCompetitionTeam, COMPETITION_TEAMS_BY_ID_CACHE } from '@app/client/resources/competitions';

export function useGetTeamById(teamId: ResourceId, enabled?: boolean) {
    return useQuery({
        queryKey: [COMPETITION_TEAMS_BY_ID_CACHE, teamId],
        queryFn: ({ signal }) => callGetCompetitionTeam({ id: teamId, settings: { signal } }),
        enabled: enabled,
    });
}
